import React from 'react';
import './IntroSection.css';
import { FaChevronDown } from 'react-icons/fa';

const IntroSection = () => {
  return (
    <div className="introduction-section">
      <div className="introduction-content">
        <h1 className="introduction-title">Artificial Intelligence Mentor</h1><hr />
        <h3 className="introduction-subtitle">Empowering Education With AI</h3>
        <p className="introduction-paragraph">
          Step into the future of learning with AIM, a cutting-edge artificial intelligence to transform education into a personalized and engaging experience.
          <span className="introduction-highlight">
            Empowering students, families, teachers, and schools, our platform makes learning more effective, interactive, and insightful than ever before.
          </span>
        </p>
      </div>
      <div className="scroll-indicator">
        <FaChevronDown className="scroll-icon" />
      </div>
    </div>
  );
};

export default IntroSection;
